/*=============================*/
/*=== Read More / Read Less ===*/
/* Vanilla JS rewrite of the original jQuery toggle (no jQuery required). */
/* A ".btn-more" button toggles the nearest preceding ".more" element.    */
(function () {
  'use strict';

  function findMoreTarget(btn) {
    // The button may be wrapped (e.g. in .button-group), so start from the
    // wrapper if present, then walk back through previous siblings.
    var node = btn.closest('.button-group') || btn;
    while (node.previousElementSibling) {
      node = node.previousElementSibling;
      if (node.classList.contains('more')) return node;
    }
    return null;
  }

  function slideToggle(el, open) {
    var duration = 200;
    if (typeof el.animate !== 'function') {
      el.style.display = open ? '' : 'none';
      return;
    }
    if (open) {
      el.style.display = '';
      var height = el.scrollHeight;
      el.style.overflow = 'hidden';
      el.animate(
        [{ height: '0px', opacity: 0 }, { height: height + 'px', opacity: 1 }],
        { duration: duration, easing: 'ease' }
      ).onfinish = function () {
        el.style.overflow = '';
      };
    } else {
      var startHeight = el.scrollHeight;
      el.style.overflow = 'hidden';
      el.animate(
        [{ height: startHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: duration, easing: 'ease' }
      ).onfinish = function () {
        el.style.display = 'none';
        el.style.overflow = '';
      };
    }
  }

  function init() {
    var buttons = document.querySelectorAll('.btn-more');
    if (!buttons.length) return;

    buttons.forEach(function (btn) {
      var target = findMoreTarget(btn);
      if (!target) return;

      // Hide the extra content on load (content stays in the DOM for SEO).
      target.style.display = 'none';

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isHidden = target.style.display === 'none';
        slideToggle(target, isHidden);
        var label = btn.querySelector('.label') || btn;
        label.textContent = isHidden ? 'Read Less' : 'Read More';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
